
import Component from '../../../assets/scripts/modules/component';
import randomIntBetween from '../../../vendor/scripts/fabrique/modules/random-int-between';

class Logo extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    if (this.element.classList.contains('logo--animated')) {
      this.animateLogo();
    }
  }

  animateLogo() {

    this.paths = [...this.element.querySelectorAll('.name-a-line')];
    this.currentIndex = randomIntBetween(0, this.paths.length -1);

    window.clearInterval(this.interval);
    this.interval = window.setInterval(this.drawStroke.bind(this), 10000);

    this.drawStroke();

  }

  drawStroke() {

    for (const path of this.paths) {
      path.setAttribute('class', 'name-a-line');
    }

    this.paths[this.currentIndex].setAttribute('class', 'name-a-line draw-stroke');

    if (this.currentIndex < this.paths.length - 1) {
      this.currentIndex += 1;
    } else {
      this.currentIndex = 0;
    }

  }

}

for (const element of document.querySelectorAll('.logo')) {
  element.instance = new Logo('logo', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/logo/logo.js